import { Navigate } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

const ProtectedRoute = ({ children }) => {
  const { currentUser, authLoading } = useAuth()

  if (authLoading) {
    return (
      <div className="flex items-center justify-center py-24">
        <p className="text-gray-500 text-lg">Checking login status...</p>
      </div>
    )
  }

  if (!currentUser) {
    return <Navigate to="/admin-login" replace />
  }

  return children
}

export default ProtectedRoute